import { useMemo } from 'react';

import useFilters from '@/hooks/useFilters.ts';

import { color_hash } from '@/utils/colorUtils.ts';

import CalendarFilterItem from './CalendarFilterItem.tsx';

interface Props {
    calendarIds: string[];
}

const CalendarList = ({ calendarIds }: Props) => {
    const { calendar_options } = useFilters();

    const selected_calendar_items = useMemo(() => {
        return calendar_options.filter((option) => calendarIds.includes(option.value));
    }, [calendar_options, calendarIds]);

    const calendar_colors = useMemo(() => {
        const colors: Record<string, string> = {};

        for (const calendar of selected_calendar_items) {
            colors[calendar.value] = color_hash.hex(calendar.value);
        }

        return colors;
    }, [selected_calendar_items]);

    return (
        <div className="flex w-full flex-col gap-6">
            {calendarIds.length > 0 && (
                <div className="max-h-48 overflow-y-auto">
                    {selected_calendar_items.map((calendar) => (
                        <CalendarFilterItem
                            key={calendar.value}
                            text={calendar.label}
                            color={calendar_colors[calendar.value]}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default CalendarList;
